import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";

const RequestIndent = () => {

  const [mode, setMode] = useState("view");
  const [requestBy, setRequestBy] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [items, setItems] = useState([]);
  const [indentList, setIndentList] = useState([]);
  const [editId, setEditId] = useState(null);
  const [locations, setLocations] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [tics, setTics] = useState([]);
  const fileRef = useRef(null);
  const [form, setForm] = useState({
    locationId: "",
    hotelId: "",
    ticId: "",
    categoryId: "",
    subCategoryId: "",
    itemId: "",
    qty: "",
    document: null
  });
  const [list, setList] = useState([]);
  useEffect(() => {
    loadCategory();
    loadLocation();
    loadTIC();
  }, []);
  const loadCategory = async () => {
    const res = await axios.get(`${REACT_APP_API_URL}api/request-indent/item-category`);
    setCategory(res.data);
  };
  const loadSubCategory = async (id) => {
    const res = await axios.get(
      `${REACT_APP_API_URL}api/request-indent/sub-category/${id}`
    );
    setSubCategory(res.data);
  };
  const loadItems = async (id) => {
    const res = await axios.get(
      `${REACT_APP_API_URL}api/request-indent/items-master?subCategoryId=${id}`
    );
    setItems(res.data);
  };
  const loadLocation = async () => {
    const res = await axios.get(`${REACT_APP_API_URL}api/request-indent/locations`);
    setLocations(res.data);
  };
  const loadHotel = async (locationId) => {
    if (!locationId) return;
    const res = await axios.get(
      `${REACT_APP_API_URL}api/request-indent/hotels/${locationId}`
    );
    setHotels(res.data || []);
  };
  const loadTIC = async () => {
    const res = await axios.get(`${REACT_APP_API_URL}api/request-indent/tic`);
    setTics(res.data);
  };
  const addItem = () => {
  if (!form.categoryId) {
    alert("Select Category");
    return;
  }
  if (!form.subCategoryId) {
    alert("Select Sub Category");
    return;
  }
  if (!form.itemId) {
    alert("Select Item");
    return;
  }
  if (!form.qty) {
    alert("Enter Quantity");
    return;
  }
  if (!/^\d+$/.test(form.qty)) {
    alert("Quantity must be numeric only");
    return;
  }
  if (Number(form.qty) <= 0) {
    alert("Qty must be greater than 0");
    return;
  }
  const exists = list.some(
    (l) => Number(l.itemId) === Number(form.itemId)
  );
  if (exists) {
    alert("Item already added");
    return;
  }
  setList([
    ...list,
    {
      itemId: form.itemId,
      itemName: items.find(
        (i) => Number(i.intItemId) === Number(form.itemId)
      )?.vchItemName,
      qty: form.qty
    }
  ]);
  setForm({
    ...form,
    categoryId: "",
    subCategoryId: "",
    itemId: "",
    qty: ""
  });
  setSubCategory([]);
  setItems([]);
};
  const loadIndentList = async () => {
  const res = await axios.get(`${REACT_APP_API_URL}api/request-indent/indent-list`);
  setIndentList(res.data);
};
  const submit = async () => {
  if (!requestBy) {
    alert("Please select Request By");
    return;
  }
  if (requestBy === "HOTEL") {
    if (!form.locationId) {
      alert("Please select Location");
      return;
    }
    if (!form.hotelId) {
      alert("Please select Hotel");
      return;
    }
  }
  if (requestBy === "TIC") {
    if (!form.ticId) {
      alert("Please select TIC");
      return;
    }
  }
  if (list.length === 0) {
    alert("Please add at least one item");
    return;
  }
  if (form.document) {
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
    ];
    if (!allowedTypes.includes(form.document.type)) {
      alert("Only PDF, JPG files allowed");
      return;
    }
    if (form.document.size > 2 * 1024 * 1024) {
      alert("File size must be less than 2MB");
      return;
    }
  }
  try {
    let url = `${REACT_APP_API_URL}api/request-indent/add-indent`;
    let method = "post";
    const formData = new FormData();
    formData.append("items", JSON.stringify(list));
    formData.append("locationId", form.locationId);
    formData.append("hotelId", form.hotelId);
    formData.append("ticId", form.ticId);
    formData.append("createdBy", 1);
    formData.append("hoId", requestBy === "HO" ? 1 : 0);
    if (form.document) {
      formData.append("document", form.document);
    }
    if (editId) {
      url = `${REACT_APP_API_URL}api/request-indent/update-indent`;
      method = "put";
      formData.append("id", editId);
    }
    const res = await axios({
      method,
      url,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    alert(res.data.message);
    setEditId(null);
    setList([]);
    setForm({
      locationId: "",
      hotelId: "",
      ticId: "",
      categoryId: "",
      subCategoryId: "",
      itemId: "",
      qty: "",
      document: null
    });
    if (fileRef.current) {
      fileRef.current.value = "";
    }
    setRequestBy("");
    setShowModal(false);
    loadIndentList();
  } catch (err) {
    console.error(err);
    alert("Something went wrong");
  }
};

  return (
    <div className="container-fluid p-4">
      <h4>Request Indent</h4>
      <div className="mb-3">
        <button
          className={`btn ${mode === "add" ? "btn-primary" : "btn-outline-primary"} me-2`}
          onClick={() => setMode("add")}
        >
          Add Indent
        </button>
         <button
            className={`btn ${mode === "view" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => {
            setMode("view");
            loadIndentList();
            }}
        >
            View Indent
        </button>
      </div>
      {mode === "add" && (
        <>
          <div className="row mb-3">
            <div className="col-md-3">
              <label>Request By</label>
              <select
                className="form-control"
                value={requestBy}
                onChange={(e) => setRequestBy(e.target.value)}
              >
                <option value="">-- Select --</option>
                <option value="HOTEL">Hotel</option>
                <option value="TIC">TIC</option>
                <option value="HO">Head Office</option>
              </select>
            </div>
            {requestBy === "HOTEL" && (
              <>
                <div className="col-md-3">
                  <label>Location</label>
                  <select
                    className="form-control"
                    value={form.locationId}
                    onChange={(e) => {
                      setForm({ ...form, locationId: e.target.value });
                      loadHotel(e.target.value);
                    }}
                  >
                    <option value="">Select Location</option>
                    {locations.map(l => (
                      <option key={l.LocationId} value={l.LocationId}>
                        {l.LocationName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label>Hotel</label>
                  <select
                    className="form-control"
                    value={form.hotelId}
                    onChange={(e) =>
                      setForm({ ...form, hotelId: e.target.value })
                    }
                  >
                    <option value="">Select Hotel</option>
                    {hotels.map(h => (
                      <option key={h.HotelId} value={h.HotelId}>
                        {h.HotelName}
                      </option>
                    ))}
                  </select>
                </div>
              </>
            )}
            {requestBy === "TIC" && (
              <div className="col-md-3">
                <label>TIC</label>
                <select
                  className="form-control"
                  value={form.ticId}
                  onChange={(e) =>
                    setForm({ ...form, ticId: e.target.value })
                  }
                >
                  <option value="">Select TIC</option>
                  {tics.map(t => (
                  <option key={t.intTICId} value={t.intTICId}>
                    {t.vchOfcName}
                  </option>
                  ))}
                </select>
              </div>
            )}
           <div className="col-md-3">
              <label>Upload Document</label>
              <input
                type="file"
                className="form-control"
                accept=".pdf,.jpg,.jpeg"
                ref={fileRef}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (!file) return;
                  const allowedTypes = [
                    "application/pdf",
                    "image/jpeg"
                  ];
                  if (!allowedTypes.includes(file.type)) {
                    alert("Only PDF/JPG allowed");
                    e.target.value = "";
                    return;
                  }
                  setForm({
                    ...form,
                    document: file
                  });
                }}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-3">
              <select
                className="form-control"
                value={form.categoryId}
                onChange={(e) => {
                  setForm({ ...form, categoryId: e.target.value });
                  loadSubCategory(e.target.value);
                }}
              >
                <option value="">Item Category</option>
                {category.map(c => (
                <option key={c.intItemCategoryId} value={c.intItemCategoryId}>
                    {c.vchItemCategoryName}
                </option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
              <select
                className="form-control"
                value={form.subCategoryId}
                onChange={(e) => {
                  setForm({ ...form, subCategoryId: e.target.value });
                  loadItems(e.target.value);
                }}
              >
                <option value="">SubCategory</option>
                {subCategory.map(s => (
                <option key={s.intItemSubCategoryId} value={s.intItemSubCategoryId}>
                    {s.vchItemSubCategoryName}
                </option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
              <select
                className="form-control"
                value={form.itemId}
                onChange={(e) =>
                  setForm({ ...form, itemId: e.target.value })
                }
              >
                <option value="">Item</option>
                {items.map(i => (
                <option key={i.intItemId} value={i.intItemId}>
                {i.vchItemName}
                </option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <input
                type="number"
                className="form-control"
                placeholder="Qty"
                value={form.qty}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setForm({ ...form, qty: value });
                  }
                }}
              />
            </div>
            <div className="col-md-1">
              <button className="btn btn-primary" onClick={addItem}>
                +
              </button>
            </div>
          </div>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Item</th>
                <th>Qty</th>
                <th>Action</th>
                <th>Document</th>
              </tr>
            </thead>
            <tbody>
              {list.map((l, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{l.itemName}</td>
                  <td>{l.qty}</td>
                  <td>
                    {l.vchDocument ? (
                      <a
                        href={`${REACT_APP_API_URL}request-indent/${l.vchDocument}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-info btn-sm"
                      >
                        View
                      </a>
                    ) : (
                      "No File"
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => {
                        const updated = list.filter((_, index) => index !== i);
                        setList(updated);
                      }}
                    >
                      X
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>          
          <button className="btn btn-success" onClick={submit}>
            {editId ? "Update" : "Submit"}
            </button>
        </>
      )}
        {mode === "view" && (
        <table className="table table-bordered mt-3">
          <thead>
            <tr>
              <th>#</th>
              <th>Indent No</th>
              <th>Unit Name</th>
              <th>Unit Location</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {indentList.map((item, i) => {
              let unitName = item.intHotelId
                ? item.HotelName
                : item.intTICId
                ? item.vchOfcName
                : "Head Office";
              let unitLocation = item.LocationName || "Head Office";
              return (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{item.vchReqIndentNo}</td>
                  <td>{unitName}</td>
                  <td>{unitLocation}</td>
                  <td>
                    <button
                      className="btn btn-warning btn-sm me-2"
                      onClick={async () => {
                        setShowModal(true);
                        setEditId(Number(item.intReqIndentMastId));
                        if (item.intHotelId) setRequestBy("HOTEL");
                        else if (item.intTICId) setRequestBy("TIC");
                        else setRequestBy("HO");
                        setForm({
                          locationId: item.intLocationId || "",
                          hotelId: item.intHotelId || "",
                          ticId: item.intTICId || "",
                          categoryId: "",
                          subCategoryId: "",
                          itemId: "",
                          qty: ""
                        });
                        if (item.intLocationId) await loadHotel(item.intLocationId);
                        const res = await axios.get(
                          `${REACT_APP_API_URL}api/request-indent/indent-details/${Number(item.intReqIndentMastId)}`
                        );
                        setList(res.data.map(d => ({
                          itemId: d.intItemId,
                          itemName: d.vchItemName,
                          qty: d.intNoOfItems
                        })));
                      }}
                    >
                      Edit
                    </button>
                    <button
                        className="btn btn-danger btn-sm me-2"
                        onClick={async () => {
                        if (window.confirm("Delete this indent?")) {
                            await axios.delete(
                            `${REACT_APP_API_URL}api/request-indent/delete-indent/${Number(item.intReqIndentMastId)}`
                            );
                            loadIndentList();
                        }
                        }}
                    >
                        Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
            {showModal && (
            <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
                <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                    <h5 className="modal-title">
                        {editId ? "Edit Indent" : "Add Indent"}
                    </h5>
                    <button
                        className="btn-close"
                        onClick={() => setShowModal(false)}
                    ></button>
                    </div>
                    <div className="modal-body">
                    <div className="row mb-3">
                        <div className="col-md-4">
                        <label>Request By</label>
                        <select
                            className="form-control"
                            value={requestBy}
                            onChange={(e) => setRequestBy(e.target.value)}
                        >
                            <option value="">-- Select --</option>
                            <option value="HOTEL">Hotel</option>
                            <option value="TIC">TIC</option>
                            <option value="HO">Head Office</option>
                        </select>
                        </div>
                        {requestBy === "HOTEL" && (
                        <>
                            <div className="col-md-4">
                            <label>Location</label>
                            <select
                                className="form-control"
                                value={form.locationId}
                                onChange={(e) => {
                                setForm({ ...form, locationId: e.target.value });
                                loadHotel(e.target.value);
                                }}
                            >
                                <option value="">Select</option>
                                {locations.map(l => (
                                <option key={l.LocationId} value={l.LocationId}>
                                    {l.LocationName}
                                </option>
                                ))}
                            </select>
                            </div>
                            <div className="col-md-4">
                            <label>Hotel</label>
                            <select
                                className="form-control"
                                value={form.hotelId}
                                onChange={(e) =>
                                setForm({ ...form, hotelId: e.target.value })
                                }
                            >
                                <option value="">Select</option>
                                {hotels.map(h => (
                                <option key={h.HotelId} value={h.HotelId}>
                                    {h.HotelName}
                                </option>
                                ))}
                            </select>
                            </div>
                        </>
                        )}
                        {requestBy === "TIC" && (
                        <div className="col-md-4">
                            <label>TIC</label>
                            <select
                            className="form-control"
                            value={form.ticId}
                            onChange={(e) =>
                                setForm({ ...form, ticId: e.target.value })
                            }
                            >
                            <option value="">Select</option>
                            {tics.map(t => (
                                <option key={t.TICId} value={t.TICId}>
                                    {t.OfcName}
                                </option>
                            ))}
                            </select>
                        </div>
                        )}
                    </div>
                    <div className="row mb-3">
                        <div className="col-md-3">
                        <select
                            className="form-control"
                            value={form.categoryId}
                            onChange={(e) => {
                            setForm({ ...form, categoryId: e.target.value });
                            loadSubCategory(e.target.value);
                            }}
                        >
                            <option value="">Category</option>
                            {category.map(c => (
                            <option key={c.ItemCategoryId} value={c.ItemCategoryId}>
                                {c.ItemCategoryName}
                            </option>
                            ))}
                        </select>
                        </div>
                        <div className="col-md-3">
                        <select
                            className="form-control"
                            value={form.subCategoryId}
                            onChange={(e) => {
                            setForm({ ...form, subCategoryId: e.target.value });
                            loadItems(e.target.value);
                            }}
                        >
                            <option value="">SubCategory</option>
                            {subCategory.map(s => (
                            <option key={s.ItemSubCategoryId} value={s.ItemSubCategoryId}>
                                {s.ItemSubCategoryName}
                            </option>
                            ))}
                        </select>
                        </div>
                        <div className="col-md-3">
                        <select
                            className="form-control"
                            value={form.itemId}
                            onChange={(e) =>
                            setForm({ ...form, itemId: e.target.value })
                            }
                        >
                            <option value="">Item</option>
                            {items.map(i => (
                            <option key={i.ItemId} value={i.ItemId}>
                                {i.ItemName}
                            </option>
                            ))}
                        </select>
                        </div>
                        <div className="col-md-2">
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Qty"
                            value={form.qty}
                            onChange={(e) =>
                            setForm({ ...form, qty: e.target.value })
                            }
                        />
                        </div>
                        <div className="col-md-1">
                        <button className="btn btn-primary" onClick={addItem}>+</button>
                        </div>
                    </div>
                    <table className="table table-bordered">
                        <tbody>
                        {list.map((l, i) => (
                            <tr key={i}>
                            <td>{l.itemName}</td>
                            <td>{l.qty}</td>
                            <td>
                                <button
                                className="btn btn-danger btn-sm"
                                onClick={() =>
                                    setList(list.filter((_, index) => index !== i))
                                }
                                >
                                X
                                </button>
                            </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    </div>
                    <div className="modal-footer">
                    <button
                        className="btn btn-secondary"
                        onClick={() => setShowModal(false)}
                    >
                        Close
                    </button>
                    <button className="btn btn-success" onClick={submit}>
                        {editId ? "Update" : "Submit"}
                    </button>
                    </div>
                </div>
                </div>
            </div>
            )}
    </div>
  );
};

export default RequestIndent;